/* eslint-disable @angular-eslint/directive-selector */
import { Directive, HostListener, Input } from '@angular/core';
import {
  TrackEventService,
  TrackEventData,
  SystemEventData,
} from '@maximizer/core/shared/data-access';

@Directive({ selector: '[trackEvent]' })
export class TrackEventDirective {
  @Input() trackEventData?: TrackEventData;
  @Input() systemData?: SystemEventData;

  constructor(private readonly trackEventService: TrackEventService) {}

  @HostListener('click')
  onClick(): void {
    if (this.trackEventData) {
      this.trackEventService.trackEvent(this.trackEventData);
    }
    if (this.systemData) {
      this.trackEventService.trackSystemEvent(this.systemData);
    }
  }
}
